export const language = {
	sectionTitle: 'Activities & Affiliations',
};
